import React from "react";
import { EmailTemplateForm } from "./EmailTemplateForm";

const CreateEmailTemplatePage: React.FC = () => {
  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4">
        <h2 className="text-base lg:text-lg font-semibold text-gray-900">
          Create Email Template
        </h2>
        <p className="text-xs lg:text-sm text-gray-500">
          Define reusable email content for your marketing campaigns.
        </p>
      </div>
      <EmailTemplateForm />
    </div>
  );
};

export default CreateEmailTemplatePage;

